import { Link } from "react-router-dom";
import { Card, CardBody, Col, Row } from "reactstrap";

interface Content {
  name: string;
  description: string;
  link: string;
  icon: string;
}

const ComplianceContentsPage = () => {

  const content: Content[] = [
    {
      name: 'Policy Hub',
      description: 'Turn policies into nudges that support compliance and culture.',
      link: '/compliance/policy-hub',
      icon: 'fas fa-file-contract'
    },
    {
      name: 'Nudge Planner',
      description: 'Organize timely nudges that guide behaviour and compliance.',
      link: '/compliance/nudge-planner',
      icon: 'fas fa-columns'
    },
    {
      name: 'Policy Scheduler',
      description: 'Schedule policies for rollout that builds lasting compliance.',
      link: '/compliance/policy-scheduler',
      icon: 'fas fa-calendar-day'
    }
  ]

  const ContentCard = (item: Content) => {
    return (
      <Card >
        <CardBody style={{minHeight:"220px"}}>
          <div className="text-center">
            <h2> <i className={item.icon}></i> {item.name}</h2>
          </div>
          <div>
            <p className="small">
              {item.description}
            </p>
          </div>
          <div className="d-flex justify-content-center">
            <Link to={item.link} className="btn btn-primary " >
                Enter 
            </Link>
          </div>
        </CardBody>
      </Card>
    )

  } 

  return (
  <>
    <Row  className="justify-content-center align-items-center" >
      <Col md={{ size: 12}}>
        <Row>
          {
            content.map((item) => (
              <Col md={4} key={item.name} className="p-1" >
                {
                  ContentCard(item)
                }
              </Col>
            ))
          }
        </Row>
      </Col>
      
    </Row>
  </>
  ); 
};

export { ComplianceContentsPage as ComplianceContents };
